import api from '../API';
import { Customer } from '../types';

export default {
  async find(id: number): Promise<Customer> {
    const response = await api.get(`customers/${id}`);
    return response.data;
  },
};
